<template>
    <!-- BEGIN FOOTER -->
    <div class='footer-wrapper'>
        <div class='footer-section f-section-1'>
            <p class=''>Copyright © 2025 <a target='_blank' href='https://deppes.com.br'>Deppes</a>, Todos os direitos
                reservados.</p>
        </div>
        <div class='footer-section f-section-2'>

        </div>
    </div>
    <!-- END FOOTER -->
</template>
